import { DateTime } from 'luxon'

export const dateIsToday = (date: DateTime, compare: DateTime = DateTime.now()) => {
  const sameDay = date.day === compare.day
  const sameMonth = date.month === compare.month
  const sameYear = date.year === compare.year

  return sameDay && sameMonth && sameYear
}
